module.exports = __webpack_public_path__ + "img/05.34da9012.svg";